/** What a new case's plaintiff field holds before the user picks or types (EE-367). */
export enum PlaintiffDefault {
  COMPANY_NAME = 'COMPANY_NAME',
  BLANK = 'BLANK'
}
